import React, { useCallback } from "react";
import { MessageType } from "../../../chat-api";
import { useMessageState, useTheme } from "../../../data";
import { CustomKeyboardDiv, KeyboardButton, LinkIcon } from "./styles";

export interface CustomKeyboardProps {
    buttons: any[],
}

const CustomKeyboard = ({buttons}: CustomKeyboardProps) => {
    const { sendMessage } = useMessageState();
    const { buttonsColor } = useTheme().body!;

    const handleClick = useCallback((btn) => {
        sendMessage({
            type: MessageType.Text,
            body: {
              body: btn.text,
              payload: btn.identifier
            },
          })
    }, [sendMessage]);

    return (
        <CustomKeyboardDiv as="sdiv">
            {
                buttons.map((btn) => (
                    btn.type === 'text' ?
                        <KeyboardButton as="sdiv"
                            color={buttonsColor!}
                            onClick={() => handleClick(btn)}
                            key={btn.identifier}
                        >
                            {btn.text}
                        </KeyboardButton>
                    :
                        <KeyboardButton as="sdiv"
                            color={buttonsColor!}
                            link={btn.type === 'link'}
                            onClick={() => window.open(btn.identifier, '_blank')}
                            key={btn.identifier}                          
                        >
                            <LinkIcon></LinkIcon> {btn.text}
                        </KeyboardButton>
                ))
            }
        </CustomKeyboardDiv>
    );
};

export default CustomKeyboard;